import * as React from "react"
import { usePdp } from '~/contexts/PdpContext'

import * as styles from "~/styles/pdp/sizes_alts.module.scss"


const FitNotice = () => {
  const { product } = usePdp()
  const { fit_notice } = product

  return (
    <div className={styles.label_note}>
      {fit_notice}
    </div>
  )
}

export default FitNotice


